import axios from "axios";

const formatFont = (font) => {
  if (!font) return "sans-serif";
  return font.includes(" ")
    ? `'${font}', sans-serif`
    : `${font}, sans-serif`;
};

export async function loadAgentBranding() {
    const { data } = await axios.get("/api/agent-branding-public");

    Object.values(data).forEach((val) => {
        const agent = val.agent_code;

        document.documentElement.style.setProperty(
            `--font-${agent}-header`,
            formatFont(val.header)
        );

        document.documentElement.style.setProperty(
            `--font-${agent}-header-weight`,
            val.header_weight
        );

        document.documentElement.style.setProperty(
            `--font-${agent}-body`,
            formatFont(val.body)
        );

        document.documentElement.style.setProperty(
            `--font-${agent}-body-weight`,
            val.body_weight
        );

        document.documentElement.style.setProperty(
            `--color-${agent}-primary`,
            `${val.primary_color}`
        );

        document.documentElement.style.setProperty(
            `--color-${agent}-secondary`,
            `${val.secondary_color}`
        );
    });
}